import styled from "styled-components"

const LoadingWrapper = styled.div`
  .perkboxLoading_error {
    margin-top: 10px;
  }
`

export default LoadingWrapper
